var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTops(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    enableBackground: "new 0 0 512 512",
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "347.692,257.069 362.493,242.27 256.108,135.885 149.724,242.27 164.525,257.069 245.642,175.953    245.642,507.298 266.575,507.298 266.575,175.953  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "203.775,402.631 203.775,381.698 67.708,381.698 67.708,25.832 444.508,25.832 444.508,381.698    308.442,381.698 308.442,402.631 465.442,402.631 465.442,4.898 46.775,4.898 46.775,402.631  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTops);
export default __webpack_public_path__ + "static/media/tops.8c23e926853311326a18f6b8f6e7cc3f.svg";
export { ForwardRef as ReactComponent };